import { Charts } from './Charts';
import PriorityChartsDataProvider from './contexts/PriorityChartsDataContext';

const PriorityWrapper = () => {
    return (
        <PriorityChartsDataProvider>
            <Charts />
        </PriorityChartsDataProvider>
    );
};

export default PriorityWrapper;
